import React from 'react';

import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';

export const SidebarData = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: <AiIcons.AiFillHome />,
    cName: 'nav-text',
  },
  {
    title: 'Master',
    icon: <IoIcons.IoIosPaper />,
    path: '',
    cName: 'nav-text',
    subNav: [
      { title: 'Other Services', path: '/master/otherservices', cName: 'sub-nav-text' },
      { title: 'Category Master', path: '/master/category_master', cName: 'sub-nav-text' },
      // { title: 'Plan Master', path: '/master/plan_master', cName: 'sub-nav-text' },
      { title: 'Plan Master', path: '/master/plan-master-new', cName: 'sub-nav-text' },
      // { title: 'Registration Form', path: '/master/registration_form', cName: 'sub-nav-text' },

     { title: 'Registration Form', path: '/master/registration_form_new', cName: 'sub-nav-text' },

      // { title: 'Registered User Updation', path: '/master/update_user', cName: 'sub-nav-text' },
      { title: 'Add Payment Plans', path: '/master/choose_payment_plan', cName: 'sub-nav-text' },
      // { title: 'Update Payment Plans', path: '/master/update_payment_plan', cName: 'sub-nav-text' },
      { title: 'Terms Conditions', path: '/master/terms_conditions', cName: 'sub-nav-text' },
      { title: 'Keyword', path: '/master/keyword', cName: 'sub-nav-text' },
      { title: 'Add Proof', path: '/master/add_proof', cName: 'sub-nav-text' },
      { title: 'Home Slider', path: '/master/home_slider', cName: 'sub-nav-text' },

      // { title: 'Priority', path: '/master/priority', cName: 'sub-nav-text' },
    ],
  },
  {
    title: 'Written Jathagam',
    icon: <IoIcons.IoIosPaper />,
    path: '',
    cName: 'nav-text',
    subNav: [
      { title: 'Add Payment', path: '/reports/payment_plan_jathagam', cName: 'sub-nav-text' },
      { title: 'Payment Report', path: '/reports/view_payment_plan_jathagam', cName: 'sub-nav-text' },
      { title: 'Payment Count', path: '/reports/Writtenjathagamcount', cName: 'sub-nav-text' },
    ],
  },

  {
    title: 'Other Payment',
    icon: <IoIcons.IoIosPaper />,
    path: '',
    cName: 'nav-text',
    subNav: [
      { title: 'Add Service', path: '/reports/Other_payment_service', cName: 'sub-nav-text' },
     
      { title: 'Other Payment Service', path: '/reports/Other_payment', cName: 'sub-nav-text' },
      { title: 'Womens Day Payment', path: '/reports/womens_day', cName: 'sub-nav-text' },

   
      { title: 'Other Payment', path: '/reports/Other_payments', cName: 'sub-nav-text' },
      { title: 'Other Payment Report', path: '/master/Other_payment_report', cName: 'sub-nav-text' },
      { title: 'Other Payment Count', path: '/master/other_payment_service_count', cName: 'sub-nav-text' },
      // { title: 'Other Service Payment', path: '/', cName: 'sub-nav-text' },
    ],
  },

  {
    title: 'Image Upload',
    icon: <IoIcons.IoIosPaper />,
    path: '/product',
    cName: 'nav-text',
    subNav: [
      { title: 'Entry Image Upload', path: '/master/entry_image_upload', cName: 'sub-nav-text' },
      { title: 'Exit Image Upload', path: '/master/exit_image_upload', cName: 'sub-nav-text' },
    
    ],
  },
  
  {
    title: 'Wallpaper',
    icon: <IoIcons.IoIosPaper />,
    path: '/wallpaper',
    cName: 'nav-text',
    subNav: [
      { title: 'Add Wallpaper Category', path: '/master/add_wallpaper_category', cName: 'sub-nav-text' },
      { title: 'Add Wallpaper Image', path: '/master/add_wallpaper_image', cName: 'sub-nav-text' },
    
    ],
  },
  
  {
    title: 'Transactions',
    icon: <IoIcons.IoIosPaper />,
    path: '/transactions',
    cName: 'nav-text',
    subNav: [
      { title: 'Group By Users', path: '/transactions/GroupView', cName: 'sub-nav-text' },
      { title: 'Date Wise Plan, Call & View Count', path: '/transactions/DateWiseGroup', cName: 'sub-nav-text' },
      { title: 'Registered Users', path: '/transactions/Registeredusers', cName: 'sub-nav-text' },
      { title: 'To be Verified', path: '/transactions/ToBeVerified', cName: 'sub-nav-text' },
      { title: 'To be KYC Verified', path: '/transactions/ToBekycVerified', cName: 'sub-nav-text' },
      { title: 'Verified Users', path: '/transactions/verified-users', cName: 'sub-nav-text' },
      { title: 'Inactive Users', path: '/transactions/inactive-users', cName: 'sub-nav-text' },
      { title: 'Payment Pending User', path: '/transactions/paymentpending', cName: 'sub-nav-text' },
      { title: 'Payment FollowUp', path: '/transactions/paymentfollowup', cName: 'sub-nav-text' },
    ],
  },  


  {
    title: 'Reports',
    icon: <IoIcons.IoIosStats />,
    path: '/reports',
    cName: 'nav-text',
    subNav: [
      { title: 'Search User', path: '/reports/SearchUser', cName: 'sub-nav-text' },
      { title: 'Enquiries', path: '/reports/enquiry', cName: 'sub-nav-text' },
      { title: 'Enquiry Follow-up', path: '/reports/enquiryfollowups', cName: 'sub-nav-text' },
      { title: 'Enquiry Deleted Report', path: '/reports/enquiry_delete_report', cName: 'sub-nav-text' },

      { title: 'Enquiry Report', path: '/reports/enquiry-report', cName: 'sub-nav-text' },

      { title: 'Expire Search User', path: '/reports/ExpireSearchUser', cName: 'sub-nav-text' },
      { title: 'Expired Search User', path: '/reports/ExpiredUserSearch', cName: 'sub-nav-text' },
      { title: 'Total Plan Report', path: '/reports/total-plan-report', cName: 'sub-nav-text' },
      { title: 'Live User Report', path: '/reports/live-user-report', cName: 'sub-nav-text' },
      { title: 'Paid User Report', path: '/reports/paid-user-report', cName: 'sub-nav-text' },
      // { title: 'Expiry Followups', path: '/reports/expiry-followups', cName: 'sub-nav-text' },
      { title: 'Paid Plan Expired Followups', path: '/reports/paidexpiredfollowups', cName: 'sub-nav-text' },
      { title: 'Free Plan Expired Followups', path: '/reports/freeexpiredfollowups', cName: 'sub-nav-text' },
      { title: 'Expiry Show Report', path: '/reports/expiry-show-report', cName: 'sub-nav-text' },
      { title: 'Payment Failure Report', path: '/reports/payment-failure-report', cName: 'sub-nav-text' },
      { title: 'Total Registered Users', path: '/reports/total-registered-users', cName: 'sub-nav-text' },
      { title: 'Accounts Report', path: '/reports/accounts-report', cName: 'sub-nav-text' },
      { title: 'Feedback Report', path: '/reports/feedback-report', cName: 'sub-nav-text' },
      { title: 'View Count', path: '/reports/view-count', cName: 'sub-nav-text' },
      { title: 'App Paid Users Report', path: '/reports/app-paid-users-report', cName: 'sub-nav-text' },
      { title: "Deleted User's", path: '/reports/deleted-users', cName: 'sub-nav-text' },
      { title: "Add Followup User's", path: '/reports/add-followup-users', cName: 'sub-nav-text' },
      { title: "View Followup User's", path: '/reports/view-followup-users', cName: 'sub-nav-text' },
      { title: 'Chatbot Report', path: '/reports/chatbot_report', cName: 'sub-nav-text' },
      { title: "Download Live User's Report", path: '/reports/download-live-users-report', cName: 'sub-nav-text' },
      { title: 'Download Mobile Number Report', path: '/reports/download-mobile-number', cName: 'sub-nav-text' },
      { title: 'Downloaded Mobile Number Report', path: '/reports/downloaded-mobile-number', cName: 'sub-nav-text' },
    ],
  },  

  // icon: <IoIcons.IoMdPeople />,
  // {
  //   title: 'Employee Details',
  //   path: '/employees',
  //   icon: <IoIcons.IoMdPeople />,
  //   cName: 'nav-text',
  //   visibleOnlyWhenLoggedIn: true,
  // },
  // {
  //   title: 'Messages',
  //   path: '/messages',
  //   icon: <FaIcons.FaEnvelopeOpenText />,
  //   cName: 'nav-text',
  // },
  // {
  //   title: 'Chat Support',
  //   path: '/support',
  //   icon: <IoIcons.IoMdHelpCircle />,
  //   cName: 'nav-text',
  // },

    {
    title: 'Accounts Report',
    path: '/accounts_report',
    icon: <IoIcons.IoMdHelpCircle />,
    cName: 'nav-text',
  },
];


